import { render, staticRenderFns } from "./new-event-dialog.vue?vue&type=template&id=79f035d7"
import script from "./new-event-dialog.vue?vue&type=script&lang=js"
export * from "./new-event-dialog.vue?vue&type=script&lang=js"
import style0 from "./new-event-dialog.vue?vue&type=style&index=0&id=79f035d7&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79f035d7')) {
      api.createRecord('79f035d7', component.options)
    } else {
      api.reload('79f035d7', component.options)
    }
    module.hot.accept("./new-event-dialog.vue?vue&type=template&id=79f035d7", function () {
      api.rerender('79f035d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/new-event-dialog.vue"
export default component.exports